module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('revision-history-panel', {
    attrs: {
      "revisionHistories": _vm.currentRevisionHistories,
      "branches": _vm.branches,
      "selectedBranch": _vm.currentBranchId,
      "selectedRevision": _vm.currentRevisionHistoryId,
      "onClickRevisionHistory": _vm.clickRevisionHistory,
      "onClickBranch": _vm.clickBranch,
      "currentAudience": _vm.currentAudience,
      "createNewBranch": _vm.createNewBranchPopover,
      "heightOfRevisions": _vm.heightOfRevisions,
      "heightOfBranches": _vm.heightOfBranches,
      "deleteBranch": _vm.deleteBranch
    }
  }) : _c('div', {
    staticClass: "missing_history_message"
  }, [_vm._v("No revision history")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d32fb584","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/revisionHistory/VuexRevisionHistoryPanel.vue
// module id = 2173
// module chunks = 0